import type { IndicatorSeries } from "../types";

export function monthlyAverageMap(series: IndicatorSeries) {
  const buckets = new Map<string, number[]>();
  for (const obs of series.observations) {
    if (obs.value == null || !Number.isFinite(obs.value)) continue;
    const month = obs.date.slice(0, 7);
    if (!/^\d{4}-\d{2}$/.test(month)) continue;
    const bucket = buckets.get(month) ?? [];
    bucket.push(obs.value);
    buckets.set(month, bucket);
  }
  return new Map([...buckets.entries()].map(([month, values]) => [
    month,
    values.reduce((sum, value) => sum + value, 0) / values.length
  ]));
}

export function monthlyRateRows(seriesList: Array<{ key: string; series: IndicatorSeries }>) {
  const maps = seriesList.map(({ key, series }) => ({ key, values: monthlyAverageMap(series) }));
  const months = [...new Set(maps.flatMap(({ values }) => [...values.keys()]))].sort();
  return months.map((month) => {
    const row: Record<string, string | number | null> = { month };
    for (const { key, values } of maps) row[key] = values.get(month) ?? null;
    return row;
  });
}


export function monthlyAverageSeries(series: IndicatorSeries, overrides?: { id?: string; name?: string; shortName?: string }): IndicatorSeries {
  const values = monthlyAverageMap(series);
  const observations = [...values.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([month, value]) => ({ date: `${month}-01`, value: Number(value.toFixed(6)) }));
  return {
    ...series,
    id: overrides?.id ?? `${series.id}__monthly_avg`,
    name: overrides?.name ?? `${series.name} 월평균`,
    shortName: overrides?.shortName ?? `${series.shortName} 월평균`,
    source: {
      ...series.source,
      frequency: "monthly",
      observationDate: observations.at(-1)?.date,
      sourceIds: [series.id],
      note: [series.source.note, "일/주 빈도 원계열은 해당 달의 유효 관측치만 단순평균합니다. 결측일을 보간하지 않습니다."].filter(Boolean).join(" ")
    },
    observations
  };
}
